"use strict";
const colors = {
  blue: {
    "50": "#E9ECFB",
    "100": "#C3CBF4",
    "200": "#9CA9ED",
    "300": "#7588E6",
    "400": "#4E66DF",
    "500": "#3F59DC",
    // digital blue
    "600": "#1F37AD",
    "700": "#324692",
    // dark blue
    "800": "#101B56",
    "900": "#080E2B"
  },
  green: {
    "50": "#f6fdf9",
    "100": "#d0f3e1",
    "200": "#9ce5bf",
    "300": "#5cd496",
    "400": "#36bc77",
    "500": "#2ea266",
    "600": "#268654",
    "700": "#1e6842",
    "800": "#185536",
    "900": "#14462c"
  },
  yellow: {
    "50": "#FFFBE5",
    "100": "#FFF3B8",
    "200": "#FFEC8A",
    "300": "#FFE45C",
    "400": "#FFDD2E",
    "500": "#FFD70C",
    // sunny yellow
    "600": "#CCAA00",
    "700": "#C18839",
    // dark ocher
    "800": "#665500",
    "900": "#332B00"
  },
  black: "#040303",
  gray: {
    "50": "#faf9f9",
    "100": "#f2f1f1",
    "200": "#e8e7e7",
    "300": "#d4d4d4",
    "400": "#aeacac",
    "500": "#817e7e",
    "600": "#575454",
    "700": "#393636",
    "800": "#231f1f",
    "900": "#1c1919"
  }
};

export { colors as default };
